import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'table_guid': 'String!',
	'timeslot_guid': '[String]!',
};

export default gql(`
	mutation table_to_timeslot( ${ HelperGraphql.createFields( fields ) } ) {
	    table_to_timeslot( ${ HelperGraphql.createVariables( fields ) } ) {
	        table {
	            guid
	        }
	        
	        timeslot {
	            guid
	        }
	    }
	}
`);

